// Services page scaffold (list of services).
import ServicesGrid from "../components/sections/services/ServicesGrid";
import { useLanguage } from "../i18n/LanguageContext";

export default function ServicesPage() {
  const { t } = useLanguage();
  const services = t.services.cards;
  const orderText = t.services.orderButton;

  return <ServicesGrid services={services} orderText={orderText} />;
}

